import { render, staticRenderFns } from "./product_weidian.vue?vue&type=template&id=c2a642e6&scoped=true&"
import script from "./product_weidian.vue?vue&type=script&lang=js&"
export * from "./product_weidian.vue?vue&type=script&lang=js&"
import style0 from "./product_weidian.vue?vue&type=style&index=0&id=c2a642e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a642e6",
  null
  
)

export default component.exports